import { css } from 'lit';
import { DebuggingConfig } from '../config/ConfigCARSx';
import { APIError, APIRequestReturn } from './api-request-types';

const parseJsonFromApiResponse = async <T>(
	apiRequestReturn: APIRequestReturn,
): Promise<T | null> => {
	if (apiRequestReturn.response?.ok !== true) {
		return null;
	}

	try {
		return (await apiRequestReturn.response.json()) as T;
	} catch (error) {
		apiRequestReturn.apiError = APIError.ResponseUnparseable;
		if (DebuggingConfig.showConsoleLogs) {
			console.error(
				`error parsing response from "${apiRequestReturn.request?.url as string}"`,
				error,
			);
		}
		return null;
	}
};

export default parseJsonFromApiResponse;
